import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function ArrowUpRightIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18.5625 6V15.75C18.5625 15.8992 18.5032 16.0423 18.3978 16.1477C18.2923 16.2532 18.1492 16.3125 18 16.3125C17.8508 16.3125 17.7077 16.2532 17.6023 16.1477C17.4968 16.0423 17.4375 15.8992 17.4375 15.75V7.3575L6.39751 18.3975C6.29088 18.4969 6.14984 18.551 6.00412 18.5484C5.85839 18.5458 5.71935 18.4868 5.61629 18.3837C5.51323 18.2807 5.4542 18.1416 5.45163 17.9959C5.44905 17.8502 5.50315 17.7091 5.60251 17.6025L16.6425 6.5625H8.25001C8.10082 6.5625 7.95775 6.50324 7.85226 6.39775C7.74677 6.29226 7.68751 6.14918 7.68751 6C7.68751 5.85082 7.74677 5.70774 7.85226 5.60225C7.95775 5.49676 8.10082 5.4375 8.25001 5.4375H18C18.1492 5.4375 18.2923 5.49676 18.3978 5.60225C18.5032 5.70774 18.5625 5.85082 18.5625 6Z" fill="#76ECA3" />
      </svg>
    </BaseIcon>
  )
}
